import * as vp from 'vopay';
import { useContext, useEffect, FunctionComponent, useState } from 'react';
import { useParams } from 'react-router-dom';
import AccountContext from '../Accounts/AccountContext';
import CreditCardTransactionInfo from './CreditCardTransactionInfo';
import useFetchCreditCardTransaction from '../../hooks/useApi/useFetchCreditCardTransaction';

type FC = FunctionComponent<vp.TransactionIdAndType>;

const CreditCardTransactionContainer: FC = (props: vp.TransactionIdAndType) => {
  const { accountId } = useParams<{ accountId: string }>();
  const { TransactionID, Type } = props;

  const { details } = useContext(AccountContext);
  let token = '';
  if (details[accountId]) {
    token = details[accountId].token;
  }
  const [CreditCardTransaction, getCreditCardTransaction] = useFetchCreditCardTransaction({
    bearer: token,
  });
  const [currentTransactionId, setCurrentTransactionId] = useState<string>();
  const [transaction, setTransaction] = useState<vp.CreditCardTransactionResponse>();
  useEffect(() => {
    if (Type === vp.TransactionType.CREDIT_CARD) {
      getCreditCardTransaction(TransactionID);
    }
  }, [currentTransactionId]);

  useEffect(() => {
    if (CreditCardTransaction) {
      setTransaction(CreditCardTransaction);
    }
  }, [CreditCardTransaction]);

  if (currentTransactionId !== TransactionID) {
    setCurrentTransactionId(TransactionID);
  }

  return <div>{transaction && <CreditCardTransactionInfo transaction={transaction} />}</div>;
};

export default CreditCardTransactionContainer;
